/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'left_arrow': {
    width: 6,
    height: 11,
    viewBox: '0 0 6 11',
    data: '<path pid="0" d="M5.129.5L6 1.347 1.734 5.5 6 9.653l-.871.847L0 5.506.006 5.5 0 5.494z" _fill="#234357" fill-rule="nonzero"/>'
  }
})
